export default __webpack_public_path__ + "static/media/uncheckedBox.1352c6b2.svg";